import React from 'react';
import { Input } from 'antd';
import './bv-input.scss';
import { IBVControl } from '../../../models/BVControls/IBVControl';
import BVControl from '../BVControl/bv-control';

interface IBVInput extends IBVControl {
    properties: any;
}

const BVInput: React.FunctionComponent<IBVInput> = ({ className, errorMessage, infoMessage, label, properties, required, isEmbedded }) =>
    <BVControl
        className={`bv-input ${className}`}
        errorMessage={errorMessage}
        infoMessage={infoMessage}
        label={label}
        required={required}
    >
        <Input
            style={{maxWidth: isEmbedded ? "none" : "300px"}}
            {...properties}
        />
    </BVControl>;

export default BVInput;